import type {CanvasRichTextBlock} from '../types';
import {MarkdownRenderer} from '../../markdown-renderer';
import type {BlockRendererProps} from './types';
import {memo} from 'react';

export const RichTextBlock = memo(
  ({block}: BlockRendererProps<CanvasRichTextBlock>) => {
    if (!block.body) {
      return null;
    }

    return (
      <div className="py-6">
        <MarkdownRenderer
          content={block.body}
          className="canvas-prose max-w-none text-sm"
        />
      </div>
    );
  },
);
RichTextBlock.displayName = 'RichTextBlock';

export const richTextBlockConfig = {
  component: RichTextBlock,
  isEmpty: (block: CanvasRichTextBlock) => !block.body?.trim(),
};
